{
  "title": "Partner",
  "subtitle": "Wiederverkäufer, die OnBrand Mail an ihre eigenen Kunden verkaufen.",
  "addPartner": "Partner hinzufügen",
  "loadError": "Partner konnten nicht geladen werden",
  "emptyTitle": "Noch keine Partner",
  "emptyDescription": "Ein Partner verkauft an seine eigenen Kunden und behält eine Marge. Fügen Sie einen hinzu und ordnen Sie ihm anschließend seine Kunden von jedem Mandanten aus zu.",
  "colPartner": "Partner",
  "colMargin": "Marge",
  "colCustomers": "Kunden",
  "colStatus": "Status",
  "colPayouts": "Auszahlungen",
  "colCustomer": "Kunde",
  "colPaid": "Bezahlt",
  "colRate": "Satz",
  "colEarned": "Verdient",
  "statusPending": "Ausstehend",
  "statusActive": "Aktiv",
  "statusSuspended": "Gesperrt",
  "payoutsNotOnboarded": "Nicht eingerichtet",
  "payoutsOnboarding": "Einrichtung",
  "payoutsReady": "Bereit",
  "payoutsRestricted": "Eingeschränkt",
  "payoutsBadge": "Auszahlungen: {{status}}",
  "marginBadge": "{{margin}} Marge",
  "commissionOwed": "Geschuldet",
  "commissionPaid": "Bezahlt",
  "commissionReversed": "Storniert",
  "commissionHeld": "Einbehalten",
  "updateError": "Dieser Partner konnte nicht aktualisiert werden.",
  "stripeOnboardingError": "Die Stripe-Einladung konnte nicht gesendet werden.",
  "partnerVerb": "{{name}} {{verb}}.",
  "partnerAdded": "{{name}} hinzugefügt.",
  "partnerAddedInvited": "{{name}} hinzugefügt und zur Stripe-Auszahlungseinrichtung eingeladen.",
  "partnerAddedNoEmail": "{{name}} hinzugefügt — Einladung konnte nicht gesendet werden. Partner öffnen und Einladung erneut senden.",
  "verbReactivated": "reaktiviert",
  "verbSuspended": "gesperrt",
  "activate": "Aktivieren",
  "reactivate": "Reaktivieren",
  "suspend": "Sperren",
  "emailStripeInvite": "Stripe-Einladung senden",
  "resendStripeInvite": "Stripe-Einladung erneut senden",
  "stripeInviteSent": "Stripe-Einrichtung an {{email}} gesendet.",
  "stripeInviteCopy": "E-Mail an {{email}} fehlgeschlagen. Einladungslink in die Zwischenablage kopiert.",
  "stripeAlreadyOnboarded": "Dieser Partner hat Stripe-Auszahlungen bereits eingerichtet.",
  "startStripeOnboarding": "Stripe-Einladung senden",
  "newOnboardingLink": "Stripe-Einladung erneut senden",
  "marginPercent": "Marge (%)",
  "billingEmail": "Rechnungs-E-Mail",
  "billingEmailDescription": "Wohin Rechnungen, Provisionsabrechnungen und die Stripe-Einladung gehen.",
  "billingEmailPlaceholder": "accounts@northern-it.example",
  "commissions": "Provision",
  "noCommissions": "Noch nichts verdient. Die Provision wird erfasst, wenn ein vermittelter Kunde eine Rechnung bezahlt, nicht wenn sie ausgestellt wird.",
  "createTitle": "Partner hinzufügen",
  "createIntro": "Ein Partner verkauft an seine eigenen Kunden und behält eine Marge am Listenpreis. Ordnen Sie ihm danach seine Kunden von jedem Mandanten aus zu.",
  "createError": "Dieser Partner konnte nicht hinzugefügt werden",
  "createErrorShort": "Dieser Partner konnte nicht hinzugefügt werden.",
  "partnerFallback": "Partner",
  "nameLabel": "Name",
  "namePlaceholder": "Northern IT",
  "slugLabel": "Slug",
  "slugDescription": "Erscheint in Portal-Routen und Protokollen. Kleinbuchstaben, Ziffern und Bindestriche.",
  "slugPlaceholder": "northern-it",
  "marginLabel": "Marge",
  "marginDescription": "Anteil am Listenpreis, den dieser Partner behält.",
  "stripePayouts": "Stripe-Auszahlungen",
  "stripeActive": "Stripe akzeptiert Überweisungen an diesen Partner. Die Provision wird stündlich gesendet.",
  "stripeNeedsInfo": "Stripe benötigt noch Informationen, bevor dieser Partner ausgezahlt werden kann. Die Provision läuft inzwischen weiter auf und wird gesendet, sobald es möglich ist.",
  "stripeNeedsOnboarding": "Dieser Partner kann keine Provision erhalten, bis die Stripe-Einrichtung abgeschlossen ist. Nur für vermittelte Kunden nötig — Großhandelspartner werden stattdessen in Rechnung gestellt.",
  "customersAttributed": "{{count}} Kunde zugeordnet. Großhandelskunden werden diesem Partner mit {{wholesale}} des Listenpreises in Rechnung gestellt; vermittelte Kunden zahlen uns direkt und die Marge wird übertragen, sobald wir bezahlt sind.",
  "customersAttributed_other": "{{count}} Kunden zugeordnet. Großhandelskunden werden diesem Partner mit {{wholesale}} des Listenpreises in Rechnung gestellt; vermittelte Kunden zahlen uns direkt und die Marge wird übertragen, sobald wir bezahlt sind.",
  "suspendedAlert": "Gesperrt: es können keine neuen Kunden zugeordnet und keine neuen Abonnements an sie abgerechnet werden. Bereits laufende Abonnements bleiben unberührt.",
  "statementError": "Abrechnung konnte nicht geladen werden",
  "multiCurrencyNote": "Diese Einträge umfassen mehr als eine Währung, daher sind die Summen oben Zählungen von Kleineinheiten und kein Betrag. Lesen Sie stattdessen die Zeilen.",
  "offboardedCustomer": "Abgemeldeter Kunde",
  "noAccessTitle": "Kein Zugriff auf Partner",
  "noAccessBody": "Wiederverkäufervereinbarungen werden vom OnBrand-Mail-Team verwaltet.",
  "viewAs": "Als Partner anzeigen",
  "viewAsStarted": "Portal wird als {{name}} angezeigt.",
  "viewAsError": "Ansicht als Partner konnte nicht gestartet werden.",
  "viewAsBannerTitle": "Ansicht als {{name}}",
  "viewAsBannerBody": "Sie sehen nur die Kunden dieses Partners und das, was deren Administratoren erreichen können. Plattform-Admin-Werkzeuge bleiben ausgeblendet, bis Sie die Ansicht beenden.",
  "exitViewAs": "Partneransicht beenden",
  "viewAsExitError": "Partneransicht konnte nicht beendet werden.",
  "resendPortalInvite": "Portaleinladung erneut senden",
  "portalAccess": "Portalzugang",
  "portalAccessHint": "Ermöglicht die Anmeldung und Verwaltung der Kunden dieses Partners. Getrennt von der Stripe-Auszahlungseinrichtung.",
  "portalInviteTitle": "Zum Portal einladen",
  "portalInviteHint": "Senden Sie {{name}} eine E-Mail, damit sie sich anmelden und ihr Partnerkonto einrichten können. Die Anmeldung reicht — kein Passwort nötig.",
  "portalInviteEmail": "Geschäftliche E-Mail",
  "portalInviteEmailDesc": "Die Adresse, mit der sie sich anmelden. Standardmäßig der Rechnungskontakt.",
  "portalInviteDifferentOrgDesc": "Partner melden sich fast immer aus ihrem eigenen Verzeichnis an. Nur abwählen, wenn sie Ihres teilen.",
  "portalInviteSent": "Portaleinladung an {{email}} gesendet.",
  "portalInviteResent": "Portaleinladung erneut an {{email}} gesendet.",
  "portalInviteNoEmailTitle": "{{email}} eingeladen — E-Mail konnte nicht gesendet werden",
  "portalInviteNoEmailBody": "Die Einladung wartet. Bitten Sie sie, sich mit dieser Adresse anzumelden; die Rolle gilt beim ersten Besuch.",
  "portalInviteErrorTitle": "Nicht eingeladen",
  "portalInviteError": "Portaleinladung konnte nicht gesendet werden."
}
